module.exports = __webpack_public_path__ + "img/50.8f7ca027.jpg";